import React, { useState } from 'react';
import Sites from '../../constants/Sites';
import { useAppContext } from '@components/Provider';

const renderUserMenuItem = (
  siteId,
  tokenCookie,
  slug,
  isOpen,
  setIsOpen,
  handleLogout,
  openLoginModal = () => {}
) => {
  const [profileOpen, setProfileOpen] = useState(false);
  let profileToggle = () => {
    setProfileOpen(!profileOpen);
  };
  const { isMobile, isTablet } = useAppContext();
  if (siteId == Sites.EARLYBIRDBOOKS) {
    return (
      <React.Fragment>
        {tokenCookie ? (
          <ul>
            <li
              className={
                isOpen
                  ? ["account-parent", "show", "item", "right", "dtoggle"].join(" ")
                  : ["account-parent", "item", (isMobile || isTablet) ? "hide" : "", "right"].join(" ")
              }
              onClick={profileToggle}
            >
              <span className="account-button">MY ACCOUNT</span>
              {profileOpen == true ? (
                <div className="account-dropdown-content">
                  <a style={{ color: 'black' }} href="/account/profile">
                    PROFILE
                  </a>
                  <a
                    onClick={handleLogout}
                    style={{
                      cursor: 'pointer',
                      // textAlign: "center",
                      color: 'black',
                    }}
                  >
                    LOGOUT
                  </a>
                </div>
              ) : (
                ''
              )}
            </li>
          </ul>
        ) : (
          <ul>
            <li className={isOpen ? 'show item right' : 'item right'}>
              <a
                style={{ cursor: 'pointer', color: 'white' }}
                onClick={openLoginModal}
              >
                LOG IN
              </a>
            </li>
          </ul>
        )}
        <style jsx>
          {`
            .account-button {
              // background-color: #4CAF50;
              color: ${slug === '/' ? 'black':'white'};
              border: none;
              padding-bottom: 10px;
            }
            .account-parent {
              position: relative;
              display: inline-block;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
            }
            .account-parent.item.hide.right {
              display: none;
            }
            .account-dropdown-content {
              color: black;
              display: none;
              position: absolute;
              z-index: 100;
              width: -webkit-fill-available;
              border: 1px solid #ccc;
            }
            .account-dropdown-content a {
              color: #0000;
              background-color: #fff;
              display: block;
              padding: 12px 12px;
              z-index: 100;
            }
            .account-dropdown-content a:hover {
              background-color: #ddd;
              color: black;
            }
            .account-parent:hover .account-dropdown-content {
              margin-top: 10px;
              color: black;
              display: block;
            }
            .account-parent:hover .account-dropdown {
              color: black;
              background-color: black;
            }
            @media (max-width: 767px) {
              .account-dropdown-content {
                position: static;
              }
            }
          `}
        </style>
      </React.Fragment>
    );
  }
};

const UserMenuItemEBB = (props) => {
  let {
    siteId,
    tokenCookie,
    slug,
    isOpen,
    setIsOpen,
    handleLogout,
    openLoginModal,
  } = props;
  return (
    <>
      {renderUserMenuItem(
        siteId,
        tokenCookie,
        slug,
        isOpen,
        setIsOpen,
        handleLogout,
        openLoginModal
      )}
    </>
  );
};

export default UserMenuItemEBB;
